import { Box } from '@chakra-ui/react';

import BriefLiveWidgetListContent from 'View/host-stream/components/brief-live-widget/section/list-content';
import BriefLiveWidgetTab from 'View/host-stream/components/brief-live-widget/section/tab';

import BriefLiveWidgetProvider from './state';
import styles from './styles.module.css';

const BriefLiveWidget = () => {
  return (
    <BriefLiveWidgetProvider>
      <Box className={styles['brief-live-widget__container']}>
        <BriefLiveWidgetTab />
        <Box className={styles['brief-live-widget__content']}>
          <BriefLiveWidgetListContent />
        </Box>
      </Box>
    </BriefLiveWidgetProvider>
  );
};

export default BriefLiveWidget;
